<template>
  <div class="offcanvas bg-gradient offcanvas-end show" id="offcanvasExample">
    <div class="offcanvas-header">
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img
            class="setting-avatar"
            src="@/assets/icons/avatar.png"
            alt="avatar"
          />
          <span class="ms-2 setting-username ff-kittithada">{{
            data.user.displayName
          }}</span>
        </div>
        <button class="setting-btn p-0" @click="$emit('onLogout')">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>
    <div class="offcanvas-body">
      <div class="row g-3">
        <div class="col-12">
          <div class="setting-title ff-kittithada fw-medium">
            {{ translate("title_setting") }}
          </div>
        </div>
        <div class="col-12">
          <div class="setting-card" @click="$emit('onOpenSite')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <div class="setting-subtitle ff-kittithada fw-medium">
                  {{ translate("title_site") }}
                </div>
                <span class="setting-value ff-kittithada">{{
                  data.formState.siteName
                }}</span>
              </div>
              <div><i class="bi bi-chevron-right"></i></div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="setting-card" @click="$emit('onOpenPhase')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <div class="setting-subtitle ff-kittithada fw-medium">
                  {{ translate("title_phase") }}
                </div>
                <span class="setting-value ff-kittithada">
                  <span v-if="data.formState.phases.length === 1">
                    {{ data.formState.phaseName }}
                  </span>
                  <span v-else>
                    <span
                      v-if="
                        data.formState.phases.length ===
                        data.option.site.filter(
                          (item) => item.value === data.formState.site
                        )[0].phases.length
                      "
                    >
                      {{ translate("title_all_phases") }}
                    </span>
                    <span v-else>
                      {{ data.formState.phases.length }}
                      {{ translate("title_phase") }}
                    </span>
                  </span>
                </span>
              </div>
              <div><i class="bi bi-chevron-right"></i></div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="setting-card" @click="$emit('onOpenTheme')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <div class="setting-subtitle ff-kittithada fw-medium">
                  {{ translate("title_theme") }}
                </div>
                <span class="setting-value ff-kittithada">
                  {{
                    translate(
                      formatThemeName(data.formState.themeId, data.option.theme)
                    )
                  }}
                </span>
              </div>
              <div><i class="bi bi-chevron-right"></i></div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="setting-card" @click="$emit('onOpenLanguage')">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <div class="setting-subtitle ff-kittithada fw-medium">
                  {{ translate("title_language") }}
                </div>
                <span class="setting-value ff-kittithada">{{
                  formatLanguageName(data.formState.language)
                }}</span>
              </div>
              <div><i class="bi bi-chevron-right"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="offcanvas-footer">
      <div class="d-flex justify-content-between">
        <div>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$emit('onBack')"
          >
            <i class="bi bi-x-lg"></i>
            <span class="ff-kittithada fw-medium ms-3">{{
              translate("title_button_close")
            }}</span>
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-primary"
            @click="$emit('onApply')"
          >
            <i class="bi bi-check-lg"></i>
            <span class="ff-kittithada fw-medium ms-3">{{
              translate("title_button_apply")
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.setting-avatar {
  width: 3rem;
  height: 3rem;
}
.setting-username {
  font-size: 2rem;
  color: var(--color-black);
}
.setting-card {
  border-radius: 1rem;
  background-color: var(--color-white);
  padding: 1.333rem 2rem;
}
.setting-card:hover {
  cursor: pointer;
}
</style>

<script setup>
import { defineProps } from "vue";
import { translate } from "@/services";
import { formatThemeName, formatLanguageName } from "@/helpers";

defineProps({
  data: Object,
});
</script>
